import { api } from "./apiClient";

const teamAPI = {
  list() {
    return api.get("/team").then((r) => r.data);
  },
  invite(payload) {
    return api.post("/team/invite", payload).then((r) => r.data);
  },
  resendInvite(userId) {
    return api.post(`/team/${userId}/resend-invite`).then((r) => r.data);
  },
  updateMember(userId, payload) {
    return api.patch(`/team/${userId}`, payload).then((r) => r.data);
  },
};

export default teamAPI;
